import { OpsEvalsLayoutComponent } from 'app/components/ops-evals/OpsEvalsLayoutComponent'

export const handle = {
  title: `Evals`,
  breadcrumb: `Evals`,
}

export default function OpsEvalsLayout(): React.ReactElement {
  return <OpsEvalsLayoutComponent />
}
